import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dead-line',
  templateUrl: './dead-line.component.html',
})
export class DeadLineComponent implements OnInit {
  constructor() { }
  @Input() postedDate: Date;
  @Input() set dueDate(value:string | Date) {
    if (value) {
      if (this.isValidDate(value))
      this.generateProgressBar(value);
      else
      this.displayingValue = value; //text. not a date 
    }
  }
  @Input() defaultTimeZoneDiffMinutes: number;
  @Input() description: string;

  public progressPercentage: string = '0%';
  public isOverdueJob: boolean = false;
  public today: Date = new Date();
  public localizedPostedDate: Date;
  public localizedDueDate: Date;
  private milliSecondsPerDay: number = 1000 * 60 * 60 * 24;
  public displayingValue: any = undefined;

  ngOnInit(): void {}


  isValidDate(value): boolean {
    if ((new Date(value)).toString() === "Invalid Date")
      return false;
    else
      return true;
  }


  generateProgressBar(dueDate) {
    if (dueDate && this.getLocalizeDate(dueDate).getFullYear() != 1) {
      this.localizedPostedDate = this.getLocalizeDate(this.postedDate);
      this.localizedDueDate = this.getLocalizeDate(dueDate);
      this.localizedPostedDate.setHours(0, 0, 0, 0);
      this.localizedDueDate.setHours(0, 0, 0, 0);
      this.getTodayWithTimeZoneDiff();
      if (this.localizedDueDate.getTime() < this.today.getTime()) {
        this.isOverdueJob = true;
        this.progressPercentage = '100%';
      } else {
        this.progressPercentage = this.getProgressPercentage(
          this.localizedPostedDate,
          this.localizedDueDate
        );
      }
      this.displayingValue = dueDate;
    }
  }

  getProgressPercentage(postedDate: Date, dueDate: Date): string {
    let totalDays =
      (dueDate.getTime() - postedDate.getTime()) / this.milliSecondsPerDay;
    let elapsedDays =
      (this.today.getTime() - postedDate.getTime()) / this.milliSecondsPerDay;

    return (elapsedDays * 100) / totalDays + '%';
  }

  private getLocalizeDate(date: Date): Date {
    return date?.toString()?.toLocaleLowerCase().endsWith('z')
      ? new Date(date)
      : new Date(date + 'z');
  }

  private getTodayWithTimeZoneDiff() {
    this.today = new Date(
      new Date().getFullYear(),
      new Date().getUTCMonth(),
      new Date().getUTCDate(),
      new Date().getUTCHours()
    );
    var diffMinutes = this.defaultTimeZoneDiffMinutes
      ? this.defaultTimeZoneDiffMinutes / 60
      : 0;
    this.today.setHours(new Date().getUTCHours() + diffMinutes, 0, 0, 0);
    this.today.setHours(0, 0, 0, 0);
  }
}
